import {
	COLOR_STEP_PANEL_BG,
	COLOR_SECONDARY_BUTTON,
	COLOR_NEUTRAL_BUTTON_ACTIVE,
	RADIUS_LG,
} from './tokens';

// Used by BookDetails, BrowseImage, PrintPattern (plain <div>)
export const stepContainerStyle = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	minHeight: '300px',
	borderRadius: RADIUS_LG,
	backgroundColor: COLOR_STEP_PANEL_BG,
	padding: '16px',
};

// Used by PrintPattern modal, AdvancedSettingsModal (MUI Modal sx)
export const modalBackdropSx = {
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	backdropFilter: 'blur(3px)',
};

// Used by PrintPattern, AdvancedSettingsModal (plain <div>)
export const modalContentStyle = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	backgroundColor: 'white',
	padding: '20px',
	borderRadius: RADIUS_LG,
};

// Flex spacer (plain <div>)
export const flexSpacerStyle = { flexGrow: 1 };

// Typography inside Buttons (MUI Typography sx)
export const buttonTypographySx = { mb: '-5px' };

// Neutral secondary button — text style (Preview Pattern)
export const neutralTextButtonSx = {
	color: COLOR_SECONDARY_BUTTON,
	'&:hover': {
		color: COLOR_NEUTRAL_BUTTON_ACTIVE,
		backgroundColor: 'rgba(0,0,0,0.04)',
	},
};
